<div class="header-container"
     [style.height.px]="height"
     [class.border-bottom]="showDivider">
  @if (showBack) {
    <button class="back-button-height" appFocusRemove (click)="onBack()">
      <app-image-loading src="assets/icon_back.svg" alt="返回" i18n-alt
                         [clickable]="true"
                         [targetWidth]="8.5"
                         [targetHeight]="16"/>
    </button>
    <button class="back-button-area" appFocusRemove (click)="onBack()">
      <span></span>
    </button>
  } @else {
    <div></div>
  }
  <button class="search-bar" appFocusRemove *ngIf="searchMode else header"
          [style.margin-right.px]="marginRight"
          (click)="toSearchPage()">
    <app-image-loading src="assets/icon_product_search.svg" alt="搜尋" i18n-alt
                       [clickable]="true"
                       [targetWidth]="15"
                       [targetHeight]="15"/>
    <!--為讓手機鍵盤, 打開有 Search 按鈕, form, action, input type search, autocapitalize, FormsModule都是必要-->
    <form action="" class="full-width" *ngIf="isBrowser">
      <input class="search-input" max="20" maxlength="20" type="search" autocomplete="off" autocapitalize="none" #input
             [class.none-point]="disabled"
             (keyup.enter)="onSearch($any($event.target).value)"
             [disabled]="disabled"
             [placeholder]="placeholder || ''"
             (input)="onKeywordChange($any($event.target).value, $any($event.target))"
             [value]="keyword">
    </form>
    <button class="zero-line-height" *ngIf="keyword.length && !disabled"
            (click)="onKeywordChange('')">
      <app-image-loading src="assets/icon_circle_clear.svg" alt="刪除" i18n-alt
                         [clickable]="true"
                         [targetWidth]="13"
                         [targetHeight]="13"/>
    </button>
  </button>
  <ng-template #header>
    <span class="static-page-title" [class.small-size]="isShopWindow">{{title}}</span>
  </ng-template>
  <div class="floating-item" *ngIf="iconTemplate">
    <ng-container [ngTemplateOutlet]="iconTemplate"/>
  </div>
  <div class="floating-item text-btn" *ngIf="textTemplate">
    <ng-container [ngTemplateOutlet]="textTemplate"/>
  </div>
  <div class="empty-item"></div>
</div>
<ng-container *ngIf="template" [ngTemplateOutlet]="template"/>
